module.exports = __webpack_public_path__ + "img/8.fbd2a0dd.jpg";